function ConfAppDirectDeposit(props) {
  return (
    <div id="confidential-direct-deposit">
      <div className="row">
        <div className="col-lg-9 col-sm-12">
          <h3>Direct Deposit Information</h3>
        </div>
      </div>

      {props.dd_info.compensationtype === 1 && (
        <>
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12">
              <strong id="conf_comptype_text">Compensation Type*</strong>
            </div>
            <div
              id="compensationtype"
              className="col-lg-3 col-md-3 col-sm-12 data"
              style={{
                marginBottom: "20px",
              }}
            >
              {props.dd_info.compensationtype === 1
                ? "MassMutual Only"
                : props.same_bank_info === true
                  ? "MassMutual Only"
                  : "MassMutual and Affiliated Broker Dealer (MMLIS Registered Business)"}
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <strong id="conf_accounttype_text">Account Type*</strong>
            </div>
            <div
              id="mmaccounttype"
              className="col-lg-3 col-md-3 col-sm-12 data"
              style={{
                marginBottom: "20px",
              }}
            >
              {props.dd_info.mmaccounttype === 1 ? "Checking" : "Savings"}
            </div>
            <div className="col-lg-3 col-md-3 col-sm-12">
              <strong id="conf_routingnum_text">Routing Number*</strong>
            </div>
            <div
              id="mmroutingnumber"
              className="col-lg-3 col-md-3 col-sm-12 data"
              style={{
                marginBottom: "20px",
              }}
            >
              {props.dd_info.mmroutingnumber}
            </div>

            <div className="col-lg-3 col-md-3 col-sm-12">
              <strong id="conf_accountnum_text">Account Number*</strong>
            </div>
            <div
              id="mmaccountnumber"
              className="col-lg-3 col-md-3 col-sm-12 data"
              style={{
                marginBottom: "20px",
              }}
            >
              {props.dd_info.mmaccountnumber}
            </div>
          </div>
        </>
      )}
      {props.dd_info.compensationtype === 2 && (
        <>
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12">
              <strong id="conf_comptype_mm">Compensation Type*</strong>
            </div>
            <div
              id="compensation_type"
              className="col-lg-3 col-md-3 col-sm-12 data"
              style={
                props.same_bank_info === true
                  ? {
                      marginBottom: "20px",
                    }
                  : {}
              }
            >
              {props.same_bank_info === true ? (
                <>
                  MassMutual and Affiliated Broker Dealer (MMLIS Registered
                  Business)
                </>
              ) : (
                <>MassMutual</>
              )}
            </div>
            {props.same_bank_info === false && (
              <>
                <div className="col-lg-3 col-md-3 col-sm-12">
                  <strong id="conf_comptype_abd">Compensation Type*</strong>
                </div>
                <div
                  id="compensation_type"
                  className="col-lg-3 col-md-3 col-sm-12 data"
                  style={{
                    marginBottom: "20px",
                  }}
                >
                  Affiliated Broker Dealer (MMLIS Registered Business)
                </div>
              </>
            )}
            <div className="col-lg-3 col-md-3 col-sm-12">
              {props.same_bank_info === true ? (
                <strong id="conf_routingnum_same">Routing Number*</strong>
              ) : (
                <strong id="conf_accounttype_same">Account Type*</strong>
              )}
            </div>
            <div
              id={
                props.same_bank_info === true
                  ? "mmroutingnumber"
                  : "mmaccounttype"
              }
              className="col-lg-3 col-md-3 col-sm-12 data"
              style={{
                marginBottom: "20px",
              }}
            >
              {props.same_bank_info === true ? (
                <>{props.dd_info.mmroutingnumber}</>
              ) : (
                <>
                  {props.dd_info.mmaccounttype === 1 ? "Checking" : "Savings"}
                </>
              )}
            </div>
            {props.same_bank_info === false && (
              <>
                <div className="col-lg-3 col-md-3 col-sm-12">
                  <strong id="conf_accounttype_diff">Account Type*</strong>
                </div>
                <div
                  id="brokaccounttype"
                  className="col-lg-3 col-md-3 col-sm-12 data"
                  style={{
                    marginBottom: "20px",
                  }}
                >
                  {props.dd_info.brokaccounttype === 1 ? "Checking" : "Savings"}
                </div>
              </>
            )}
            <div className="col-lg-3 col-md-3 col-sm-12">
              {props.same_bank_info === true ? (
                <strong id="conf_accounttype_diff">Account Type*</strong>
              ) : (
                <strong id="conf_routingnum_diff">Routing Number*</strong>
              )}
            </div>
            <div
              id={
                props.same_bank_info === true
                  ? "mmaccounttype"
                  : "mmroutingnumber"
              }
              className="col-lg-3 col-md-3 col-sm-12 data"
              style={{
                marginBottom: "20px",
              }}
            >
              {props.same_bank_info === true ? (
                <>
                  {props.dd_info.mmaccounttype === 1 ? "Checking" : "Savings"}
                </>
              ) : (
                <>{props.dd_info.mmroutingnumber}</>
              )}
            </div>
            {props.same_bank_info === false && (
              <>
                <div className="col-lg-3 col-md-3 col-sm-12">
                  <strong id="conf_routingnum_diff2">Routing Number*</strong>
                </div>
                <div
                  id="brokroutingnumber"
                  className="col-lg-3 col-md-3 col-sm-12 data"
                  style={{
                    marginBottom: "20px",
                  }}
                >
                  {props.dd_info.brokroutingnumber}
                </div>
              </>
            )}
            <div className="col-lg-3 col-md-3 col-sm-12">
              <strong id="conf_accountnum_diff2">Account Number*</strong>
            </div>
            <div
              id="mmaccountnumber"
              className="col-lg-3 col-md-3 col-sm-12 data"
              style={{
                marginBottom: "20px",
              }}
            >
              {props.dd_info.mmaccountnumber}
            </div>
            {props.same_bank_info === false && (
              <>
                <div className="col-lg-3 col-md-3 col-sm-12">
                  <strong id="conf_accountnum_diff3">Account Number*</strong>
                </div>
                <div
                  id="brokaccountnumber"
                  className="col-lg-3 col-md-3 col-sm-12 data"
                  style={{
                    marginBottom: "20px",
                  }}
                >
                  {props.dd_info.brokaccountnumber}
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default ConfAppDirectDeposit;
